import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Hjem from '../views/Hjem.vue';
import Om from '../views/Om.vue';
import Nyheder from '../views/Nyheder.vue';
import Hunde from '../views/Hunde.vue';
import Hvalpe from '../views/Hvalpe.vue';
import Resultater from '../views/Resultater.vue';
import Salg from '../views/Salg.vue';
import Kontakt from '../views/Kontakt.vue';
import Links from '../views/Links.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Hjem',
    component: Hjem,
  },
  {
    path: '/Om',
    name: 'Om',
    component: Om,
  },
  {
    path: '/nyheder',
    name: 'Nyheder',
    component: Nyheder,
  },
  {
    path: '/hunde',
    name: 'Hunde',
    component: Hunde,
  },
  {
    path: '/hvalpe',
    name: 'Hvalpe',
    component: Hvalpe,
  },
  {
    path: '/resultater',
    name: 'Resultater',
    component: Resultater,
  },
  {
    path: '/salg',
    name: 'Salg',
    component: Salg,
  },
  {
    path: '/kontakt',
    name: 'Kontakt',
    component: Kontakt,
  },
  {
    path: '/links',
    name: 'Links',
    component: Links,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
